const e = "styles-module__container___llo7F", s = "styles-module__message___5IaTz", t = {
  container: e,
  message: s
};
export {
  e as container,
  t as default,
  s as message
};
